const light = {
  mainBackground: '#fff',
  mainSidebarBackground: '#fff',
  menuItemBackground: '#fff',
  menuItemBorderActive: '#0074DF',
  menuItemBackgroundActive: '#0074DF',
  menuItemTextPrimary: '#9AA2AC',
  menuItemTextActive: '#fff',
  headerText: '#2B3364',
};
export default light;
